import { addSegment } from 'actions/navigation'


export const setBookingMethod = (bookingMethod) => ({
  type: 'SET_BOOKING_METHOD',
  bookingMethod
})

export const setSelectedSpots = (spots) => ({
  type: 'SET_SELECTED_SPOTS',
  spots
})

export const spotSelectionError = () => ({
  type: 'SPOT_SELECTION_ERROR'
})

export const selectSpot = (spot) => ({
  type: 'SELECT_SPOT_TIME',
  spot
})

export const addSpotToCheckQueue = (spot) => ({
  type: 'ADD_TO_CHECK_QUEUE',
  spot
})

export const removeSpotFromCheckQueue = (spot) => ({
  type: 'REMOVE_FROM_CHECK_QUEUE',
  spot
})

export const addOrRemoveSpot = (spot) => ({
  type: 'ADD_OR_REMOVE_SPOT',
  spot
})

export const updateSelectedSpots = (spots) => ({
  type: 'UPDATE_SELECTED_SPOTS',
  spots
})

export const addSpotFromParams = (spot) => ({
  type: 'ADD_SPOT_FROM_PARAMS',
  spot
})

export const confirmSpot = (spot) => (
  addSegment(spot.start_time)
)
